module.exports = __webpack_public_path__ + "static/media/mall-in.f5a78a45.png";